<template>
  <el-container class="ids-common-layout">
    <el-header height="50px">
      <!-- <Header></Header> -->
    </el-header>
    <el-container class="outContainer" style="height: 0px;">
      <el-aside width="50px" class="idsLeftNav" v-show="!isH5Modle">
        <!-- <component :is="currentLeftNav"></component> -->
        <!-- <LeftNav></LeftNav> -->
      </el-aside>
      <el-container>
        <el-header height="30px" class="breadcrumb">
          <Breadcrumb></Breadcrumb>
        </el-header>
        <el-main>
          <div class="topDom"></div>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
// import Header from "@/components/common/Header.vue"
import Breadcrumb from "@/components/common/Breadcrumb.vue"
// import LeftNav from "@/components/common/LeftNav.vue"
export default {
  components: {
    // Header,
    // LeftNav,
    Breadcrumb
  },
  data() {
    return {
      isH5Modle: false,
      h5Width: 768
    }
  },
  mounted() {
    let _this = this
    try {
      this.isH5Modle = window.innerWidth < this.h5Width
      document.querySelector(".outContainer").style.height =
        window.innerHeight - 50 + "px"
    } catch (error) {
      console.log(error)
    }
    window.addEventListener("resize", function() {
      try {
        _this.isH5Modle = window.innerWidth < _this.h5Width
        document.querySelector(".outContainer").style.height =
          window.innerHeight - 50 + "px"
      } catch (error) {
        console.log(error)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.ids-common-layout {
  // width: 1220px;
  margin: 0 auto;
  position: relative;
  .el-header {
    padding: 0;
    background-color: #1c2b36;
  }
  .el-aside {
    background-color: #1c2b36;
    color: #ffffff;
  }
  .el-main {
    background-color: #fafafa;
    position: relative;
    .topDom {
      position: absolute;
      top: 0;
    }
  }
}
</style>
